import axios from 'axios';
import cfg from '../cfg';

axios.defaults.baseURL = cfg.baseURL;

let authToken = localStorage.getItem('token')
axios.defaults.headers.common['Authorization'] = authToken;
export default axios;